import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { Settings } from 'src/types/global';

import { restoreSettings } from './utils';

// Use string literal instead of importing THEMES to avoid circular dependency
// during module initialization (THEMES is imported from src/theme which has
// complex Material-UI dependencies that may not be initialized yet)
const initialStateValue: Settings = {
  direction: 'ltr',
  responsiveFontSizes: true,
  theme: 'DARK',
};

const initialState = restoreSettings() || initialStateValue;

const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    saveSettings(state: Settings, action: PayloadAction<Settings>) {
      state.direction = action.payload.direction;
      state.responsiveFontSizes = action.payload.responsiveFontSizes;
      state.theme = action.payload.theme;
    },
  },
});

export const { reducer } = slice;

export default slice;
